import { render, staticRenderFns } from "./ExportsDataTable.vue?vue&type=template&id=918ec538&scoped=true"
import script from "./ExportsDataTable.vue?vue&type=script&lang=js"
export * from "./ExportsDataTable.vue?vue&type=script&lang=js"
import style0 from "./ExportsDataTable.vue?vue&type=style&index=0&id=918ec538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918ec538",
  null
  
)

export default component.exports